module.exports = __webpack_public_path__ + "img/rote-add.5a07c18e.svg";